import styled from 'styled-components'
import { TextBuilder } from './TextBuilder'
import { useEffect, useState } from 'react'
import agedata from './group_texts.json'

var Text = new TextBuilder()

const DynamicText = ({ group, age }: { group: number; age: number }) => {
  const [displayText, setDisplayText] = useState<(string | JSX.Element)[]>()

  let age_string = age === 18 ? '18-65' : '65+'

  let agegroup = agedata.find((d:any) => {
    return d.age_group === age_string && d.wealth_group === group
  })

  // if (!agegroup) agegroup = agedata[0]
  useEffect(() => {
    Text.clear()
      .add(<b>Mit Ihrer Kombination aus Einkommen und Vermögen gehören Sie </b>)
      .decide_by_index(group, [
        <b>zu den am wenigsten wohlhabenden 10 Prozent der Schweiz.</b>,
        <>
          <b>zu den Armutsgefährdeten. </b>In der Schweiz sind 10 Prozent
          weniger wohlhabend als Sie, 75 Prozent gehören zu einer höheren
          Wohlstandsgruppe.
        </>,
        <>
          <b>
            zur unteren Mitte. In der Schweiz sind 25 Prozent weniger wohlhabend
            als Sie, 50 Prozent gehören zu einer höheren Wohlstandsgruppe.
          </b>
        </>,
        <>
          <b>
            zur Mitte. In der Schweiz sind 50 Prozent weniger wohlhabend als
            Sie, 25 Prozent gehören zu einer höheren Wohlstandsgruppe.
          </b>
        </>,
        <>
          <b>
            zur oberen Mitte. In der Schweiz sind 75 Prozent weniger wohlhabend
            als Sie, 10 Prozent gehören zu einer höheren Wohlstandsgruppe.
          </b>
        </>,
        <>
          <b>zu den wohlhabendsten 10 Prozent der Schweiz.</b>
        </>,
      ])
      .add(' ')
      .decide_by_index(
        group,
        age === 18
          ? [
              <>
                Personen Ihrer Gruppe haben ohne Vermögen ein Einkommen bis zu{' '}
                {formatNumber(agegroup?.maxlohn1 || 0)} Fr. pro Jahr - oder, bei
                sehr tiefem Einkommen, ein Vermögen bis zu{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                Personen Ihrer Gruppe haben bei einem Vermögen von{' '}
                {formatNumber(formatNumber(agegroup?.vermoegen1 || 0) || 0)} Fr.
                ein Einkommen zwischen{' '}
                {formatNumber(formatNumber(agegroup?.minlohn1 || 0) || 0)} und{' '}
                {formatNumber(formatNumber(agegroup?.maxlohn1 || 0) || 0)} Fr.
                pro Jahr. – ohne Einkommen liegt das Vermögen zwischen{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} und{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                Personen Ihrer Gruppe haben bei einem Vermögen von
                beispielsweise {formatNumber(agegroup?.vermoegen1 || 0)} Fr. ein
                Einkommen zwischen {formatNumber(agegroup?.minlohn1 || 0)} und{' '}
                {formatNumber(agegroup?.maxlohn1 || 0)} Fr. pro Jahr.
              </>,
              <>
                Personen Ihrer Gruppe haben bei einem Vermögen von
                beispielsweise {formatNumber(agegroup?.vermoegen1 || 0)} Fr. ein
                Einkommen von über {formatNumber(agegroup?.minlohn1 || 0)} Fr.
                pro Jahr. Liegt das Jahreseinkommen bei{' '}
                {formatNumber(agegroup?.lohn2 || 0)} reicht bereits ein Vermögen
                von {formatNumber(agegroup?.minvermoegen2 || 0)} um zu dieser
                Gruppe zu gehören.
              </>,
              <>
                Personen Ihrer Gruppe haben bei einem Vermögen von
                beispielsweise {formatNumber(agegroup?.vermoegen1 || 0)} Fr. ein
                Einkommen von über {formatNumber(agegroup?.minlohn1 || 0)} Fr.
                pro Jahr. Liegt das Jahreseinkommen bei{' '}
                {formatNumber(agegroup?.lohn2 || 0)} reicht bereits ein Vermögen
                von {formatNumber(agegroup?.minvermoegen2 || 0)} um zu dieser
                Gruppe zu gehören.
              </>,
              <>
                Personen Ihrer Gruppe haben bei einem Vermögen von{' '}
                {formatNumber(agegroup?.vermoegen1 || 0)}
                Fr. ein Einkommen über {formatNumber(
                  agegroup?.minlohn1 || 0
                )}{' '}
                Fr. pro Jahr - oder, bei einem Einkommen von{' '}
                {formatNumber(agegroup?.lohn2 || 0)} Fr. ein Vermögen über{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} Fr.
              </>,
            ]
          : [
              <>
                In Ihrer Altergruppe hängt die Zuteilung verstärkt vom Vermögen
                ab. Personen Ihrer Gruppe haben ohne Vermögen ein Einkommen bis
                zu {formatNumber(agegroup?.maxlohn1 || 0)} Fr. pro Jahr - oder,
                bei sehr tiefem Einkommen, ein Vermögen bis zu{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                In Ihrer Altergruppe hängt die Zuteilung verstärkt vom Vermögen
                ab. Personen Ihrer Gruppe haben bei einem Vermögen von
                {formatNumber(agegroup?.vermoegen1 || 0)} Fr. ein Einkommen
                zwischen {formatNumber(agegroup?.minlohn1 || 0)} und
                {formatNumber(agegroup?.maxlohn1 || 0)} Fr. pro Jahr. – ohne
                Einkommen liegt das Vermögen zwischen{' '}
                {formatNumber(agegroup?.minvermoegen2 || 0)} und{' '}
                {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                In Ihrer Altergruppe hängt die Zuteilung verstärkt vom Vermögen
                ab. Personen Ihrer Gruppe haben beispielsweise bei einem
                Einkommen von {formatNumber(agegroup?.lohn2 || 0)} Fr. ein
                Vermögen zwischen {formatNumber(agegroup?.minvermoegen2 || 0)}{' '}
                und {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                In Ihrer Altergruppe hängt die Zuteilung verstärkt vom Vermögen
                ab. Personen Ihrer Gruppe haben beispielsweise bei einem
                Einkommen von {formatNumber(agegroup?.lohn2 || 0)} Fr. ein
                Vermögen zwischen {formatNumber(agegroup?.minvermoegen2 || 0)}{' '}
                und {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                In Ihrer Altergruppe hängt die Zuteilung verstärkt vom Vermögen
                ab. Personen Ihrer Gruppe haben beispielsweise bei einem
                Einkommen von {formatNumber(agegroup?.lohn2 || 0)} Fr. ein
                Vermögen zwischen {formatNumber(agegroup?.minvermoegen2 || 0)}{' '}
                und {formatNumber(agegroup?.maxvermoegen2 || 0)} Fr.
              </>,
              <>
                In Ihrer Altergruppe hängt die Zuteilung verstärkt vom Vermögen
                ab. Personen Ihrer Gruppe haben grösstenteils ein Vermögen von
                über {formatNumber(agegroup?.minvermoegen2 || 0)} Fr.
              </>,
            ]
      )



    setDisplayText(Text.get())
  }, [group, age])

  return <DynamicTextContainer>{displayText}</DynamicTextContainer>
}
const DynamicTextContainer = styled.div`
  margin-bottom: 60px;
  background-color: var(--yellow-main);
  color: var(--brandblue-main);

  padding: 20px;
  border-radius: 10px;
  font-size: 18px;
  line-height: 1.6em;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`

export default DynamicText
const formatNumber = (num: string | number | undefined) => {
  if (!num && num !== 0) return ''
  return +num < 10000 ? num : num.toLocaleString('de-CH')
}
